import axiosClient from '../configs/axios';


class GrnService {
    // Get list 
    async getGrnList(params) {
        try {
            const login_details = sessionStorage.getItem("loginUser");
        const userD = JSON.parse(login_details);
        const userInfo = userD?.result?.userInfo;
        

        const unit_id = userInfo?.depot_id || userInfo?.plant_id ;
            const response = await axiosClient.get(
                `/grn/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}&unit_id=${unit_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addGrn(data) {
        try {
            const response = await axiosClient.post('/grn/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteGrn(data) {
        try {
            const response = await axiosClient.put(`/grn/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new GrnService(); 